import React, { useState } from "react";
import ChatBot from "react-simple-chatbot";

import { ThemeProvider } from "styled-components";

function CustomChatbot(props) {
  const [opened, setOpen] = useState(false);

  const toggleFloating = ({ opened }) => {
    if (opened) {
      setOpen({ opened });
    } else {
      setOpen(false);
    }
  };

  const config = {
    width: "500px",
    height: "300px",
    floating: true
  };

  const theme = {
    background: "white",
    fontFamily: "Arial, Helvetica, sans-serif",
    headerBgColor: "#00B2B2",
    headerFontColor: "#fff",
    headerFontSize: "25px",
    botBubbleColor: "#00B2B2",
    botFontColor: "#fff",
    userBubbleColor: "#fff",
    userFontColor: "#4c4c4c"
  };
  const steps = [
    {
      id: "Greet",
      message: "Hello, Your good name?",
      trigger: "Waiting user input for name"
    },

    {
      id: "Waiting user input for name",
      user: true,
      trigger: "Asking options to know about me"
    },
    {
      id: "Asking options to know about me",
      message: "Hi {previousValue}, what you want to know!",
      trigger: "Displaying options to know"
    },
    {
      id: "Displaying options to know",
      options: [
        {
          value: "My Professional",
          label: "My Professional",
          trigger: "Asking for my career"
        },
        {
          value: "My Personal",
          label: "My Personal",
          trigger: "Not available"
        }
      ]
    },
    {
      id: "Not available",
      options: [
        {
          value: "Naa... Naa.., Connect me in twitetr ",
          label: "Naa... Naa.., Connect me in Twitter",
          trigger: () => {
            window.open("https://twitter.com/WhizzWords", "_blank");
            return "Displaying options to know";
          }
        },
        {
          value: "Professional",
          label: "Professional",
          trigger: "Asking for my career"
        }
      ]
    },
    {
      id: "Asking for my career",
      options: [
        {
          value: "Skills",
          label: "Skills",
          trigger: "Asking for my Skills"
        },
        {
          value: "Works",
          label: "Works",
          trigger: "Asking for my Works"
        },
        {
          value: "Experience",
          label: "Experience",
          trigger: "Asking for my Experience"
        }
      ]
    },
    {
      id: "Asking for my Skills",
      options: [
        {
          value: true,
          label: "You Sure !",
          trigger: () => {
            setOpen(false);
            window.location.hash = "#/skills";
            return "Result Page";
          }
        },
        {
          value: false,
          label: "No",
          trigger: "Done"
        }
      ]
    },
    {
      id: "Asking for my Works",
      options: [
        {
          value: true,
          label: "You Sure !",
          trigger: () => {
            setOpen(false);
            window.location.hash = "#/work";
            return "Result Page";
          }
        },
        {
          value: false,
          label: "No",
          trigger: "Done"
        }
      ]
    },
    {
      id: "Asking for my Experience",
      options: [
        {
          value: true,
          label: "You Sure !",
          trigger: () => {
            setOpen(false);
            window.location.hash = "#/experience";
            return "Result Page";
          }
        },
        {
          value: false,
          label: "No",
          trigger: "Done"
        }
      ]
    },
    {
      id: "Result Page",
      options: [
        {
          value: true,
          label: "May be",
          trigger: "Asking for my career"
        },
        {
          value: "Immressed ?",
          label: "Immressed ?",
          trigger: "May be"
        },
        {
          value: false,
          label: "No",
          trigger: "Done"
        }
      ]
    },

    {
      id: "May be",
      message: "Hire me !",
      trigger: "Hire"
    },
    {
      id: "Hire",
      options: [
        {
          value: true,
          label: "Yes ",
          trigger: () => {
            setOpen(false);
            window.location.hash = "#/contact";
            return "Asking for my career";
          }
        },
        {
          value: false,
          label: "No",
          trigger: () => {
            setOpen(false);
            return "Done";
          }
        }
      ]
    },

    {
      id: "Done",
      message: "See You Later, Have a great day !!",
      end: true
    }
  ];

  return (
    <ThemeProvider theme={theme}>
      <ChatBot
        steps={steps}
        {...config}
        headerTitle="Achyuth Bot"
        enableMobileAutoFocus={true}
        opened={opened}
        toggleFloating={toggleFloating}
      />
    </ThemeProvider>
  );
}
export default CustomChatbot;
